module.exports = __webpack_public_path__ + "img/196.a85c55a6.jpg";